import TempCache from '../enums/TempCache';

const getNameMessage = function () {
    const getName = ApexChat.localStorageAPI.Get(TempCache.VISITOR_NAME);

    return {
        name: getName
    };
};
export default getNameMessage;
